import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Icon from 'components/system/Icon';
import withAttachCardDialog from 'components/hoc/withAttachCardDialog';
import colors from 'styles/colors';

const PaymentMethodEmptyCard = ({ openAttachCard }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
    <Button
      variant="contained"
      type="primary"
      onClick={openAttachCard}
      fullWidth
    >
      <Icon
        name="credit_card"
        size="20px"
        color={colors.text.primary}
        sx={{ marginRight: '10px' }}
      />
      Add a card
    </Button>
  </Box>
);

export default withAttachCardDialog(PaymentMethodEmptyCard);
